import Page from 'components/page/Page';
import PageWrapper from 'components/pageWrapper/PageWrapper';

import { useEnv } from 'hooks/useEnv';

import DailyDeals from './dailyDeals/DailyDeals';
import StoppedSalesModal from './stoppedSales/StoppedSalesModal';
import TopOffers from './topOffers/TopOffers';

const Deals = () => {
  const { salesStopped } = useEnv();

  return (
    <Page className="tw-overflow-x-hidden" pageBackground="dark" hideLoader requireTermsOfServiceConsents withScrollbar>
      <PageWrapper pageType="minimized" twClassName="xl:tw-min-w-[1260px] 2xl:tw-min-w-[1436px]">
        <DailyDeals />
        <TopOffers />
        {salesStopped && <StoppedSalesModal />}
      </PageWrapper>
    </Page>
  );
};

export default Deals;
